import { combineReducers } from "redux";
import citySelectorSlice from "./citySelectorSlice";
import trainStationSlice from "./trainStationSlice";

const rootReducer = combineReducers({
  citySelector: citySelectorSlice,
  trainStation: trainStationSlice,
});

export default rootReducer;
